<template>
  <add-edit-dialog v-show="visible">
    <crm-panel title="转换">
      <div class="page-buttons">
        <crm-button :text="'保存'" @click="handleSave()"> </crm-button>
        <crm-button
          :buttonType="'plain'"
          :text="'取消'"
          @click="handleCancel()"
        >
        </crm-button>
      </div>
      <div class="container">
        <el-radio v-model="radio" label="1">关联到已有客户</el-radio>
        <div v-if="radio === '1'" class="connect-div">
          <span class="transfer-title">客户名称</span>
          <cusname-select
            :val="customerId"
            :customName="cusName"
            @change="handleCusnameChange"
          >
          </cusname-select>
          <span class="link" v-if="customerId" @click="toDetail">查看</span>
          <p v-if="customerUid">
            系统存在一条相似客户，销售线索（{{
              detail.name
            }}）已自动匹配，若匹配错误请手动选择客户
          </p>
        </div>
        <el-radio v-model="radio" label="2">新建客户</el-radio>

        <div v-if="radio === '2' && isCusHold" style="flex: 1; overflow: auto;">
          <add-form ref="form" :detail="detail"></add-form>
        </div>
      </div>
    </crm-panel>

    <el-dialog
      title="查看客户"
      width="60%"
      :visible.sync="detailVisible"
      append-to-body
      @close="detailVisible = false"
    >
      <el-form :model="transferDetail" label-width="120px" ref="form">
        <el-row>
          <el-col :span="24">
            <el-form-item label="客户类型：">
              <span>{{ transferDetail.categoryName }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="客户名称：">
              <span>{{ transferDetail.name }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="统一社会信用代码：">
              <span>{{ transferDetail.creditCode }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="注册资金(万元)：">
              <span>{{ transferDetail.capital }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="规模(人)：">
              <span>{{ transferDetail.scale }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="地区：">
              <span>{{
                `${transferDetail.province}-${transferDetail.city}-${transferDetail.district}`
              }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="详细地址：">
              <span>{{ transferDetail.streetAddress }}</span>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <crm-button
          :buttonType="'plain'"
          :text="'取消'"
          @click="detailVisible = false"
        >
        </crm-button>
        <crm-button :text="'确定'" @click="detailVisible = false"></crm-button>
      </div>
    </el-dialog>
  </add-edit-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import city from '@/scripts/city-diction';
import AddEditDialog from '@/components/base/addEditDialog';
import CrmPanel from '@/components/base/crmPanel';
import CrmButton from '@/components/base/crmButton';
import CusnameSelect from '@/components/business/clue/cusname-select';
import AddForm from '@/components/business/custom/form';

export default {
  props: {
    visible: Boolean,
    detail: Object,
    customerUid: String,
    customName: String,
    cluesId: String,
  },
  components: {
    AddEditDialog,
    CrmPanel,
    CrmButton,
    CusnameSelect,
    AddForm,
  },
  data() {
    return {
      radio: '',
      detailVisible: false,
      customerId: null,
      cusName: null,
      isCusHold: false,
    };
  },
  computed: {
    ...mapGetters({
      transferDetail: 'clue/transferDetail',
      customerHoldBoolean: 'customer/customerHoldBoolean',
      userInfo: 'authority/userInfo',
    }),
  },
  watch: {
    visible(val) {
      if (val) {
        this.cusName = this.customName;
        if (this.customerUid) this.radio = '1';
        if (!this.customerUid) this.radio = '2';
        this.customerId = this.customerUid;
      }
    },
    radio: {
      handler(val) {
        if (val === '2') {
          this.getCusHolding();
        }
      },
      immediate: true,
    },
  },
  methods: {
    ...mapActions({
      getTransferDetail: 'clue/getTransferDetail',
      addCustom: 'clue/addCustom',
      connectToCustom: 'clue/connectToCustom',
      getCustomerHold: 'customer/getCustomerHold',
    }),
    handleCusnameChange(val) {
      this.customerId = val;
    },
    toDetail() {
      this.getTransferDetail({ customerId: this.customerId }).then(() => {
        this.detailVisible = true;
      });
    },
    handleSave() {
      if (this.radio === '1') this.handleSaveOldCustom();
      if (this.radio === '2') this.handleSaveAddCustom();
    },
    handleSaveOldCustom() {
      this.connectToCustom({
        cluesId: this.cluesId,
        customerId: this.customerId,
      }).then(() => {
        this.$message.success('关联成功！');
        this.$emit('success');
        this.$emit('close');
      });
    },
    async getCusHolding() {
      await this.getCustomerHold({
        salesmanCode: this.userInfo.userUid,
      });
      if (!this.customerHoldBoolean) {
        this.$confirm(
          '您目前所保有的客户数量已达到最大限制，继续新增的客户将被自动释放到公海！是否继续？',
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          },
        ).then(() => {
          this.isCusHold = true;
        });
      } else {
        this.isCusHold = true;
      }
    },
    async handleSaveAddCustom() {
      this.$refs.form.handleReturnData().then((params) => {
        if (params) {
          this.addCustom({
            ...params,
            cluesId: this.cluesId,
          }).then(() => {
            this.$message.success('新增成功！');
            this.$emit('success');
            this.$emit('close');
          });
        }
      });
    },
    handleCancel() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  display: flex;
  flex-direction: column;
  overflow: auto;
  flex: 1;
  padding: 20px 0;
  .el-radio {
    display: block;
    line-height: 30px;
  }
  .connect-div {
    padding: 20px;
    line-height: 30px;
    margin-bottom: 20px;
    .transfer-title {
      display: inline-block;
      width: 100px;
      font-weight: bold;
    }
    p {
      margin-left: 100px;
    }
  }
}
</style>
